import React, { FC } from 'react';

interface ITransactions {
  className: string;
}
const Transactions: FC<ITransactions> = (props) => (
  <svg
    {...props}
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0001 5.94543V0.999364C13.0001 0.734985 12.8941 0.47999 12.7066 0.292506C12.5191 0.105022 12.2651 0 11.9998 0H1.0003C0.448119 0 0 0.447183 0 0.999364V16.9994C0 17.2647 0.104998 17.5187 0.292506 17.7062C0.480014 17.8937 0.735009 17.9997 1.0003 17.9997H11.9998C12.2651 17.9997 12.5191 17.8937 12.7066 17.7062C12.8941 17.5187 13.0001 17.2647 13.0001 16.9994V12.9446H11.9998V16.9994H1.0003V0.999364H11.9998V5.94543H13.0001Z"
      fill="#213F7D"
    />
    <path
      d="M1.99963 13.9946H10.9995V14.9949H1.99963V13.9946Z"
      fill="#213F7D"
    />
    <path
      d="M1.99963 2.49548H10.9995V3.49578H1.99963V2.49548Z"
      fill="#213F7D"
    />
    <path
      d="M5.74955 15.4946C5.47394 15.4946 5.24988 15.7186 5.24988 15.9952C5.24988 16.2708 5.47394 16.4948 5.74955 16.4948H7.24952C7.52606 16.4948 7.75012 16.2708 7.75012 15.9952C7.75012 15.7186 7.52607 15.4946 7.24952 15.4946H5.74955Z"
      fill="#213F7D"
    />
    <path
      d="M10.9994 6.44507H6.49952V4.44543L2.50024 6.94475L6.49952 9.44501V7.44537H10.9994V6.44507Z"
      fill="#213F7D"
    />
    <path
      d="M16 9.44503L11.9998 6.94476V8.94534H7.49988V9.9447H11.9998V11.9453L16 9.44503Z"
      fill="#213F7D"
    />
  </svg>
);

export default Transactions;
